import withIcon from './NewIcon';
// @ts-ignore
import IconBookM from './icon/m/book.s.svg';

export default withIcon(IconBookM);
